export default __webpack_public_path__ + "static/media/cross_ic.b894e1c9.svg";